
import React, { useCallback, useEffect, useState } from "react";
import { Col } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import topbar from "topbar";
import { ResultItem } from "./partials/ResultItem";
import { LotoRuleSetSelect } from "./partials/LotoRuleSetSelect";
import { getTicketRollStatus } from "../../../controller/api/systemApi";
import TicketSourceSummary from "../../statistic/ticket-source-summary/TicketSourceSummary";
import { isSuperAdminUser } from "../../../helper/adminSession";
import ModuleMaintainPanel from "../../../components/ModuleMaintainPanel";

export default () => {
  const [cookies] = useCookies(['lottmekong']);
  const isSuperAdmin = isSuperAdminUser();

  const [loaded, setLoaded] = useState(true);

  const [isRollEnabled, setIsRollEnabled] = useState(false);

  const getAllFunc = useCallback(async () => {
    setLoaded(false)

    const resp = await getTicketRollStatus(cookies.lottmekong, '', false, true)

    setLoaded(true)

    setIsRollEnabled(resp)

  }, [cookies.lottmekong])

  useEffect(() => {
    if (loaded) {
      topbar.hide();
    } else {
      topbar.show();
    }
  }, [loaded])

  useEffect(() => {
    document.title = "Trang chủ"
  }, []);

  useEffect(() => {
    topbar.config({
      autoRun: true,
      barThickness: 3,
      barColors: {
        '0': 'rgba(26,  188, 156, .9)',
        '.25': 'rgba(52,  152, 219, .9)',
        '.50': 'rgba(241, 196, 15,  .9)',
        '.75': 'rgba(230, 126, 34,  .9)',
        '1.0': 'rgba(211, 84,  0,   .9)'
      },
      shadowBlur: 10,
      shadowColor: 'rgba(0,   0,   0,   .6)'
    })
    getAllFunc();
  }, [getAllFunc])

  return (
    <>
      <Col className="mb-3">
        <ModuleMaintainPanel moduleIds={['loto']} />
      </Col>
      <Col>
        <ResultItem isRollEnabled={isRollEnabled} />
      </Col>
      {isSuperAdmin && (
        <Col className="mb-3">
          <LotoRuleSetSelect />
        </Col>
      )}
      <Col className="mb-3">
        <TicketSourceSummary
          embedded
          summaryType="loto"
          hideGameFilter
        />
      </Col>
    </>
  );
};
